import React, { useEffect, useState } from "react";
import { useI18n } from "../../i18n/I18nContext";
import { api, apiError } from "../../lib/api";
import { toast } from "sonner";

export default function Bookings() {
  const { t, fmtSAR, fmtDate, isAr } = useI18n();
  const [rows, setRows] = useState([]);
  const [branches, setBranches] = useState([]);
  const [filter, setFilter] = useState({ branch_id: "", status: "" });

  const load = () => {
    const qs = new URLSearchParams(Object.entries(filter).filter(([, v]) => v)).toString();
    api.get(`/admin/bookings${qs ? "?" + qs : ""}`).then((r) => setRows(r.data)).catch(() => {});
  };
  useEffect(() => { api.get("/branches").then((r) => setBranches(r.data)); }, []);
  useEffect(() => { load(); }, [filter]);

  const setStatus = async (id, status) => {
    try { await api.put(`/admin/bookings/${id}/status`, { status }); toast.success(t("common.save")); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const pay = async (b) => {
    const amt = prompt(isAr ? "المبلغ" : "Amount", b.amount_due);
    if (!amt) return;
    try { await api.post("/admin/payments", { booking_id: b.id, amount: parseFloat(amt), method: "cash", idempotency_key: `${b.id}-${Date.now()}` }); toast.success(t("admin.record_payment")); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const statusColor = (s) => ({ confirmed: "bg-green-100 text-green-700", pending_payment: "bg-amber-100 text-amber-700", completed: "bg-blue-100 text-blue-700", cancelled: "bg-red-100 text-red-700" }[s] || "bg-slate-100 text-slate-600");
  const bn = (id) => { const b = branches.find((x) => x.id === id); return b ? (isAr ? b.name_ar : b.name_en) : id?.slice(0, 6); };

  return (
    <div>
      <h1 className="text-xl font-bold text-slate-900">{t("admin.bookings")}</h1>
      <div className="mt-4 flex flex-wrap gap-2">
        <select value={filter.branch_id} onChange={(e) => setFilter({ ...filter, branch_id: e.target.value })} data-testid="filter-branch" className="rounded-lg border border-border px-3 py-2 text-sm">
          <option value="">{t("common.all")} · {t("admin.branches")}</option>
          {branches.map((b) => <option key={b.id} value={b.id}>{isAr ? b.name_ar : b.name_en}</option>)}
        </select>
        <select value={filter.status} onChange={(e) => setFilter({ ...filter, status: e.target.value })} data-testid="filter-status" className="rounded-lg border border-border px-3 py-2 text-sm">
          <option value="">{t("common.all")} · {t("common.status")}</option>
          {["pending_payment", "confirmed", "completed", "cancelled"].map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>
      <div className="mt-4 overflow-x-auto rounded-xl border border-border bg-white">
        <table className="w-full min-w-[720px] text-sm">
          <thead className="border-b border-border bg-slate-50 text-start text-xs text-slate-500">
            <tr>{[t("common.name"), t("admin.branches"), t("common.date"), t("common.total"), t("account.paid"), t("common.status"), ""].map((h, i) => <th key={i} className="px-4 py-3 text-start font-medium">{h}</th>)}</tr>
          </thead>
          <tbody>
            {rows.map((b) => (
              <tr key={b.id} data-testid={`admin-booking-row-${b.id}`} className="border-b border-border last:border-0">
                <td className="px-4 py-3"><div className="font-medium text-slate-900">{b.customer_name}</div><div className="text-xs text-slate-400" dir="ltr">{b.customer_phone}</div></td>
                <td className="px-4 py-3 text-slate-600">{bn(b.branch_id)}</td>
                <td className="px-4 py-3 text-slate-600">{fmtDate(b.start).greg}<div className="text-xs text-slate-400">{fmtDate(b.start).time}</div></td>
                <td className="px-4 py-3 font-medium">{fmtSAR(b.amount_total)}</td>
                <td className="px-4 py-3 text-slate-600">{fmtSAR(b.amount_paid)}</td>
                <td className="px-4 py-3"><span className={`rounded-full px-2 py-1 text-xs font-medium ${statusColor(b.status)}`}>{b.status}</span></td>
                <td className="px-4 py-3">
                  <div className="flex gap-1">
                    {b.amount_due > 0 && b.status !== "cancelled" && <button onClick={() => pay(b)} data-testid={`pay-${b.id}`} className="rounded-md border border-border px-2 py-1 text-xs hover:border-primary">{t("admin.record_payment")}</button>}
                    {b.status === "confirmed" && <button onClick={() => setStatus(b.id, "completed")} data-testid={`complete-${b.id}`} className="rounded-md bg-blue-600 px-2 py-1 text-xs text-white">{t("admin.mark_completed")}</button>}
                    {b.status === "pending_payment" && <button onClick={() => setStatus(b.id, "confirmed")} className="rounded-md bg-green-600 px-2 py-1 text-xs text-white">{t("admin.mark_confirmed")}</button>}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {rows.length === 0 && <div className="py-12 text-center text-slate-400">{t("common.none")}</div>}
      </div>
    </div>
  );
}
